export const mappingByKey = {
  Dutch: 'NL',
  English: 'GB',
  French: 'FR',
  German: 'DE',
  Italian: 'IT',
  Spanish: 'ES',
  Czech: 'CZ',
  Turkish: 'TR',
  Hungarian: 'HU',
  Russian: 'RU',
  Polish: 'PL',
  Greek: 'GR',
  Lithuanian: 'LT',
  Arabic: 'AR',
};

export const mappingByTranslation = {
  GB: ['Englisch', 'English', 'Engels'],
  RU: ['Russisch', 'Russian', 'Russisch'],
  NL: ['Niederländisch', 'Dutch', 'Nederlands'],
  FR: ['Französisch', 'French', 'Frans'],
  DE: ['Deutsch', 'German', 'Duitse'],
  IT: ['Italienisch', 'Italian', 'Italiaans'],
  ES: ['Spanisch', 'Spanish', 'Spaans'],
  CZ: ['Tschechisch', 'Czech', 'Tsjechisch'],
  TR: ['Türkisch', 'Turkish', 'Turks'],
  HU: ['Ungarisch', 'Hungarian', 'Hongaars'],
  PL: ['Polnisch', 'Polish', 'Pools'],
  GR: ['Griechisch', 'Greek', 'Grieks'],
  LT: ['Litauisch', 'Lithuanian', 'Litouws'],
  AR: ['Arabisch', 'Arabic', 'Arabisch'],
};
